import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BuildingDetailsStyled } from './style';

type Props = {
  buildingCreatedAt: string;
  buildingName: string;
  addressOfProperty: string;
};

const BuildingInformation = ({
  buildingCreatedAt,
  buildingName,
  addressOfProperty,
}: Props) => {
  return (
    <BuildingDetailsStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        BUILDING INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled className="buildingInfo">
          <Typography fontColor="dark" className="key">
            Building Created At :
          </Typography>
          <Typography variant="normal" className="value">
            {buildingCreatedAt}
          </Typography>
        </InfoRowStyled>
        <InfoRowStyled className="buildingInfo">
          <Typography fontColor="dark" className="key">
            Building Name :
          </Typography>
          <Typography variant="normal" className="value">
            {buildingName}
          </Typography>
        </InfoRowStyled>
        <InfoRowStyled className="buildingInfo">
          <Typography fontColor="dark" className="key">
            Address of Property :
          </Typography>
          <Typography variant="normal" className="value">
            {addressOfProperty}
          </Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BuildingDetailsStyled>
  );
};

export default BuildingInformation;
